import { handleNumberInputWheel } from '../../../../../helpers'

const MarketTradeInput = ({ placeholder, currency, onChange, value }) => {
  return (
    <div className="w-full flex items-center">
      <input
        type="number"
        className="without-arrows bg-transparent w-full outline-none px-[12px] py-[6px] border-[#e0e3eb] border-[1px] rounded-l-[5px]"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onWheel={handleNumberInputWheel}
      />

      <span className="px-[12px] py-[6px] bg-[#eff2f6] text-[#4a4a4a] font-normal text-base border-l-[0] border-[#e0e3eb] border-[1px] rounded-r-[5px]">
        {currency}
      </span>
    </div>
  )
}

export default MarketTradeInput
